'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  margin: 0;\n'], ['\n  margin: 0;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  margin: 0.5em 0.4em 0 0.4em;\n  padding: 6px 10px;\n  background: ', ';\n  color: ', ';\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n'], ['\n  margin: 0.5em 0.4em 0 0.4em;\n  padding: 6px 10px;\n  background: ', ';\n  color: ', ';\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  text-align: left;\n  padding: 0.5em;\n  display: flex;\n  margin: 0 0.4em;\n\n  h4 {\n    font-size: 0.9em;\n    font-weight: 500;\n    margin-bottom: 0;\n    text-transform: uppercase;\n    color: ', ';\n  }\n'], ['\n  text-align: left;\n  padding: 0.5em;\n  display: flex;\n  margin: 0 0.4em;\n\n  h4 {\n    font-size: 0.9em;\n    font-weight: 500;\n    margin-bottom: 0;\n    text-transform: uppercase;\n    color: ', ';\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  flex: 1;\n  letter-spacing: 1px;\n  text-align: left;\n'], ['\n  flex: 1;\n  letter-spacing: 1px;\n  text-align: left;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  flex: 1;\n  text-align: right;\n'], ['\n  flex: 1;\n  text-align: right;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  border: 1px solid ', ';\n  margin: 0 0.4em;\n  border-radius: 5px;\n  border-top-left-radius: ', ';\n  border-top-right-radius: ', ';\n'], ['\n  border: 1px solid ', ';\n  margin: 0 0.4em;\n  border-radius: 5px;\n  border-top-left-radius: ', ';\n  border-top-right-radius: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _color = require('../../color');

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var WidgetContainer = _styledComponents2.default.div(_templateObject);

var Header = _styledComponents2.default.div(_templateObject2, _color2.default.blue_main, _color2.default.white);

var Title = _styledComponents2.default.div(_templateObject3, _color2.default.blue_main);

var TitleLeft = _styledComponents2.default.div(_templateObject4);

var TitleRight = _styledComponents2.default.div(_templateObject5);

var Content = _styledComponents2.default.div(_templateObject6, _color2.default.blue_accent, function (props) {
  return props.header ? '0' : '5px';
}, function (props) {
  return props.header ? '0' : '5px';
});

var MozartWidgetLayOut = function (_Component) {
  _inherits(MozartWidgetLayOut, _Component);

  function MozartWidgetLayOut() {
    _classCallCheck(this, MozartWidgetLayOut);

    return _possibleConstructorReturn(this, (MozartWidgetLayOut.__proto__ || Object.getPrototypeOf(MozartWidgetLayOut)).apply(this, arguments));
  }

  _createClass(MozartWidgetLayOut, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          header = _props.header,
          innerTitle = _props.innerTitle,
          navigation = _props.navigation,
          contentStyle = _props.contentStyle,
          themeId = _props.themeId;


      return _react2.default.createElement(
        WidgetContainer,
        { 'data-qa': this.props.testId, 'data-theme': themeId },
        title && _react2.default.createElement(
          Title,
          { 'data-theme': 'MozartWidgetLayOut-Title' },
          _react2.default.createElement(
            TitleLeft,
            null,
            _react2.default.createElement(
              'h4',
              null,
              title
            )
          ),
          navigation && _react2.default.createElement(
            TitleRight,
            null,
            navigation
          )
        ),
        header && _react2.default.createElement(
          Header,
          null,
          header
        ),
        _react2.default.createElement(
          Content,
          { 'data-theme': 'MozartWidgetLayOut-Content', header: header, style: contentStyle ? contentStyle : {} },
          innerTitle && _react2.default.createElement(
            Title,
            { 'data-theme': 'MozartWidgetLayOut-Title' },
            _react2.default.createElement(
              TitleLeft,
              null,
              _react2.default.createElement(
                'h4',
                null,
                innerTitle
              )
            )
          ),
          this.props.children
        )
      );
    }
  }]);

  return MozartWidgetLayOut;
}(_react.Component);

MozartWidgetLayOut.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** title outside of the container */
  title: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  /** title inside of the container */
  innerTitle: _propTypes2.default.oneOfType([_propTypes2.default.string]),
  /** navigation on the right outside of the container */
  navigation: _propTypes2.default.node,
  /** header */
  header: _propTypes2.default.node,
  /** content */
  children: _propTypes2.default.node,
  /** style override for content container */
  contentStyle: _propTypes2.default.object
};
MozartWidgetLayOut.defaultProps = {
  testId: 'MozartWidgetLayOut',
  themeId: 'MozartWidgetLayOut'
};
exports.default = MozartWidgetLayOut;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartLayOut/MozartWidgetLayOut/MozartWidgetLayOut.js
// module id = 1959
// module chunks = 1